import { styled } from '@mui/material';

const StyledLogo = styled('svg')<{ noBackground?: boolean }>(
  ({ theme, noBackground }) => ({
    backgroundColor: noBackground ? 'transparent' : '#1e1e1e',
    padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
    borderRadius: `${theme.spacing(1)}`,
  })
);

export type FigmaLogoProps = {
  noBackground?: boolean;
};

export const FigmaLogo = ({ noBackground }: FigmaLogoProps) => (
  <StyledLogo
    noBackground={noBackground}
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_527_569)">
      <path
        d="M2.70771 13.6677C3.97246 13.6677 4.99892 12.6722 4.99892 11.4455V9.22327H2.70771C1.44297 9.22327 0.416504 10.2188 0.416504 11.4455C0.416504 12.6722 1.44297 13.6677 2.70771 13.6677Z"
        fill="#0ACF83"
      />
      <path
        d="M0.416504 6.99889C0.416504 5.77223 1.44297 4.77667 2.70771 4.77667H4.99892V9.22112H2.70771C1.44297 9.22112 0.416504 8.22556 0.416504 6.99889Z"
        fill="#A259FF"
      />
      <path
        d="M0.416504 2.55554C0.416504 1.32887 1.44297 0.333313 2.70771 0.333313H4.99892V4.77776H2.70771C1.44297 4.77776 0.416504 3.7822 0.416504 2.55554Z"
        fill="#F24E1E"
      />
      <path
        d="M5 0.333313H7.29121C8.55596 0.333313 9.58242 1.32887 9.58242 2.55554C9.58242 3.7822 8.55596 4.77776 7.29121 4.77776H5V0.333313Z"
        fill="#FF7262"
      />
      <path
        d="M9.58242 6.99889C9.58242 8.22556 8.55596 9.22112 7.29121 9.22112C6.02646 9.22112 5 8.22556 5 6.99889C5 5.77223 6.02646 4.77667 7.29121 4.77667C8.55596 4.77667 9.58242 5.77223 9.58242 6.99889Z"
        fill="#1ABCFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_527_569">
        <rect
          width="9.16667"
          height="13.3333"
          fill="white"
          transform="translate(0.416504 0.333313)"
        />
      </clipPath>
    </defs>
  </StyledLogo>
);
